import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton
} from '@mui/material';
import { Close as CloseIcon } from "@mui/icons-material";

interface UnableToDeliverModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
  reason: string;
  setReason: (value: string) => void;
  type: "unable" | "partial";
}

const UnableToDeliverModal: React.FC<UnableToDeliverModalProps> = ({
  open,
  onClose,
  onSubmit,
  reason,
  setReason,
  type,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 24px',
          fontSize: '16px',
        }}
      >
        {type === "unable" ? "Reason For Reject" : "Reason For Partial Delivery"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {type === "unable" ? (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="reason-label">Select Reason</InputLabel>
            <Select
              labelId="reason-label"
              value={reason}
              label="Select Reason"
              onChange={(e) => setReason(e.target.value)}
            >
              <MenuItem value="Customer Cancelled">Customer Cancelled</MenuItem>
              <MenuItem value="Customer not available">Customer not available</MenuItem>
              <MenuItem value="Wrong address">Wrong address</MenuItem>
              <MenuItem value="Payment issue">Payment issue</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>
        ) : (
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Enter Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            variant="outlined"
            sx={{ mt: 2 }}
          />
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button className="custom-cancel-button" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={() => onSubmit(reason)}
          variant="contained"
          className="custom-button"
          disabled={!reason.trim()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnableToDeliverModal;
